import { useEffect } from "react";

function ensureMeta(selector, attributeName, attributeValue) {
  if (typeof document === "undefined") {
    return null;
  }

  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute(attributeName, attributeValue);
    document.head.appendChild(node);
  }

  return node;
}

export default function SEOHead({
  title,
  description,
  canonicalUrl,
  robots,
  ogTitle,
  ogDescription,
}) {
  useEffect(() => {
    if (typeof document === "undefined") {
      return undefined;
    }

    const previousTitle = document.title;
    const descriptionNode = ensureMeta('meta[name="description"]', "name", "description");
    const robotsNode = robots
      ? ensureMeta('meta[name="robots"]', "name", "robots")
      : null;
    const twitterNode = ensureMeta('meta[name="twitter:card"]', "name", "twitter:card");
    const ogTitleNode = ensureMeta('meta[property="og:title"]', "property", "og:title");
    const ogDescriptionNode = ensureMeta(
      'meta[property="og:description"]',
      "property",
      "og:description",
    );

    let canonicalNode = canonicalUrl
      ? document.head.querySelector('link[rel="canonical"]')
      : null;

    if (canonicalUrl && !canonicalNode) {
      canonicalNode = document.createElement("link");
      canonicalNode.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalNode);
    }

    if (title) {
      document.title = title;
    }

    if (descriptionNode && description) {
      descriptionNode.setAttribute("content", description);
    }

    if (robotsNode && robots) {
      robotsNode.setAttribute("content", robots);
    }

    if (twitterNode) {
      twitterNode.setAttribute("content", "summary_large_image");
    }

    ogTitleNode.setAttribute("content", ogTitle || title || "");
    ogDescriptionNode.setAttribute("content", ogDescription || description || "");

    if (canonicalNode && canonicalUrl) {
      canonicalNode.setAttribute("href", canonicalUrl);
    }

    return () => {
      document.title = previousTitle;
    };
  }, [canonicalUrl, description, ogDescription, ogTitle, robots, title]);

  return null;
}
